import * as React from "react";

import { Step } from "../../FormParts/Tour/TourTypes";
import { noop } from "../../../../../Common/TypingUtils";

import { TourStepsContextObject } from "./TourStepsContextObject";

export function useTourStepRef(
    step: Step | (() => Step)
): (node: undefined | null | HTMLElement | React.ReactInstance) => void {
    const tourStepContext = React.useContext(TourStepsContextObject);
    const [node, setNode] = React.useState<HTMLElement | React.ReactInstance>();

    const ref = React.useCallback((x: null | undefined | HTMLElement | React.ReactInstance) => {
        setNode(x ?? undefined);
    }, []);

    React.useEffect(() => {
        if (tourStepContext == undefined) {
            return noop;
        }
        if (node) {
            const stepObject = typeof step === "function" ? step() : step;
            tourStepContext.addTourStep(stepObject, node);
        }
        return () => {
            if (node) {
                tourStepContext.removeTourStep(node);
            }
        };
    }, [node]);

    return ref;
}
